export enum BlockError {
	blocked_by_other = 'blocked_by_other',
	blocked_by_commerce = 'blocked_by_commerce',
	blocked_by_me = 'blocked_by_me',
	unblock_request = 'unblock_request',
	call_easy_permission = 'call_easy_permission',
	rbidos_customer = 'rbidos_customer',
	min_company_existence_check_failed = 'min_company_existence_check_failed',
	unblock_request_file = 'unblock_request_file',
	blocked_by_priority_channel = 'blocked_by_priority_channel',
}

export type BlockErrorProp<R> = { [key in keyof typeof BlockError]?: R }
